export function Convert24HoursTo12HoursFormat(time: string) {
    const [hora, minutos] = time.split(":");
    const now = new Date();
    now.setHours(parseInt(hora, 10));
    now.setMinutes(parseInt(minutos, 10));
    return now.toLocaleString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}